import {
  Box,
  Button,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import React from "react";
import { increaseVotes } from "../../utils/api";

export const getVoteCount = (item) =>
  (Array.isArray(item?.likes) ? item.likes.length : 0) +
  (Number(item?.bonusVotes) || 0);

const IncreaseVotes = ({ item, reload }) => {
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [count, setCount] = React.useState(1);
  const [loading, setLoading] = React.useState(false);

  const currentVotes = getVoteCount(item);

  const handleIncrease = async () => {
    const amount = Number(count);
    if (!Number.isInteger(amount) || amount < 1) {
      toast({
        title: "Invalid amount",
        description: "Enter a whole number of at least 1.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setLoading(true);
    const [success, data] = await increaseVotes(item._id, amount);
    setLoading(false);

    if (success) {
      toast({
        title: "Votes increased",
        description: `Total votes are now ${data?.totalVotes ?? currentVotes + amount}.`,
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      setCount(1);
      onClose();
      reload?.();
    } else {
      toast({
        title: "Error",
        description: data?.message || "Failed to increase votes.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    }
  };

  return (
    <>
      <Box display="flex" flexDirection="column" gap={2} minW="110px">
        <Text fontSize="sm" fontWeight="semibold">
          {currentVotes} votes
        </Text>
        <Button size="sm" colorScheme="orange" variant="solid" onClick={onOpen}>
          Increase
        </Button>
      </Box>

      <Modal isOpen={isOpen} onClose={onClose} size="sm">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Increase Votes</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text fontSize="sm" mb={2}>
              {item?.name || "This content"} currently has{" "}
              <b>{currentVotes}</b> votes
              {item?.bonusVotes
                ? ` (${item.likes?.length || 0} user + ${item.bonusVotes} admin)`
                : ""}
              .
            </Text>
            <Text fontSize="sm" mb={2} fontWeight="medium">
              Add how many votes?
            </Text>
            <Input
              type="number"
              min={1}
              step={1}
              value={count}
              onChange={(e) => setCount(e.target.value)}
            />
          </ModalBody>
          <ModalFooter>
            <Button
              colorScheme="orange"
              mr={3}
              onClick={handleIncrease}
              isLoading={loading}
            >
              Add Votes
            </Button>
            <Button onClick={onClose} isDisabled={loading}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default IncreaseVotes;
